import React from "react";
import BulkUploadDriverSecondaryLocality from "../../components/BulkUploadDriverSecondaryLocality";

const BulkUploadDriverSecondaryLocalityManager = (props) => {
    return <BulkUploadDriverSecondaryLocality />;
};

export default BulkUploadDriverSecondaryLocalityManager;